import React, {Component} from "react";
import config from 'react-global-configuration';
import {Nav, Navbar, NavItem} from "react-bootstrap";
import jwt_decode from "jwt-decode";
import {Link} from "react-router-dom";
import $ from "jquery";


class communicationNavbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emiMenus:[]
        };

    }
    componentDidMount() {
        this.getEmiRoutes();
    }

    getEmiRoutes(){
        let emiMenus = [];
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        
        let accessPermissions = [];
        if(tokenPermission != null) {
            const decoded_permission = jwt_decode(tokenPermission);
            accessPermissions = decoded_permission.accessPermissions;
        }
        let emiRoutes = [
            {
                path: "/manage-communication",
                name: "Manage Communications",
                menu_per: "be_manage_communication",
                icon: "pe-7s-server",
                //component: Unmapped_View,
                layout: "/admin",
                isDrop: false,
                submenus:[]
            },
            {
                path: "/email-users",
                name: "Email Users",
                menu_per: "be_email_users",
                icon: "pe-7s-server",
                //component: Mapped_View,
                layout: "/admin",
                isDrop: false,
                submenus:[]
            }
        ];

        emiRoutes.map((menuName, index) => {
            accessPermissions.map((permissionName, i) => {
                if(permissionName.access_name==menuName.menu_per) {
                    emiMenus.push(emiRoutes[index]);
                }
            });
        });
        this.setState({
            emiMenus: emiMenus
        })
    }

    render() {
        let menus = this.state.emiMenus.map((menu, index) =>{
            return (
                <NavItem key={index + "_" + 5} eventKey={index + "_" + 5} componentClass={Link} href={menu.layout+menu.path } to={menu.layout+menu.path}>
                    {menu.name}
                </NavItem>
            )
        });

        return (
                <div className="container-fluid">
                    <div className = "row">
                        
                                <Navbar className="CommunicationNav" fluid >
                                    <Navbar.Header>
                                        {/*<Navbar.Brand>*/}
                                        {/*  <a href="#pablo">{this.props.brandText}</a>*/}
                                        {/*</Navbar.Brand>*/}
                                        <Navbar.Toggle onClick={this.mobileSidebarToggle} />
                                    </Navbar.Header>
                                    <Navbar.Collapse>
                                        <Nav pullLeft>
                                            {menus}
                                        </Nav>
                                    </Navbar.Collapse>
                                </Navbar>

                            

                    </div>
                </div>
            

        );

    }


}
export default communicationNavbar;